import React from 'react';
import PageTemplate from '../components/PageTemplate';

/**
 * Page Conditions générales
 */
const Terms = () => {
  return <PageTemplate slug="terms" />;
};

export default Terms;
